<template>
  <div id="wrapper">
    <main-header></main-header>
    <main-content></main-content>
  </div>
</template>
<script>
import MainHeader from "./components/Headers/Header.vue";
import MainContent from "./components/MainContent/CardsParrent.vue";
export default {
  components: {
    MainHeader,
    MainContent,
  },
};
</script>
<style>
@import "./assets/nulling/style.css";
</style>
